import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../AuthContext';

const API = process.env.REACT_APP_API_URL || '';

export default function AcceptInvite({ onAccepted }) {
  const { updateUser } = useAuth();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [tokenInvalid, setTokenInvalid] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (t) {
      setToken(t);
    } else {
      setTokenInvalid(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 6) return setError('Password must be at least 6 characters');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/accept-invite`, { token, password });
      localStorage.setItem('hrtrack_token', res.data.token);
      updateUser(res.data.user);
      setDone(true);
      setTimeout(() => {
        window.history.replaceState({}, '', '/');
        onAccepted(res.data);
      }, 1200);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  if (done) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
        <div style={{ background: 'var(--glass-2)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '40px 36px', width: 380, textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
          <div style={{ fontSize: '3rem', marginBottom: 12 }}>🎉</div>
          <h2 style={{ color: 'var(--text)', marginBottom: 8 }}>You're all set!</h2>
          <p style={{ color: 'var(--muted)' }}>Your account is activated. Taking you to your dashboard…</p>
        </div>
      </div>
    );
  }

  if (tokenInvalid) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
        <div style={{ background: 'var(--glass-2)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '40px 36px', width: 380, textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
          <div style={{ fontSize: '2rem', marginBottom: 12 }}>⚠️</div>
          <h2 style={{ color: 'var(--text)', marginBottom: 8 }}>Invalid invite link</h2>
          <p style={{ color: 'var(--muted)' }}>This invite link is missing or malformed. Please ask your admin to send you a new invite.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
      <div style={{ background: 'var(--glass-2)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '40px 36px', width: 400, boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--text)' }}>HR<span style={{ color: '#4f46e5' }}>Track</span></div>
          <div style={{ color: 'var(--muted)', marginTop: 6, fontSize: '0.9rem' }}>You've been invited! Set your password to get started.</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Min 6 characters"
              required
              autoFocus
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Repeat your password"
              required
              autoComplete="new-password"
            />
          </div>

          {error && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: '0.875rem' }}>
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: '10px', marginTop: 4 }}>
            {loading ? 'Activating…' : 'Activate My Account'}
          </button>
        </form>
      </div>
    </div>
  );
}
